const Offcanvas = require('./common/offcanvas');
const {initialFocus} = require('./common/initial-focus');

document.addEventListener('DOMContentLoaded', function () {
	Offcanvas.init();
	initialFocus();
})
